window.CM_PORTS = [
"Aabenraa - Dänemark",
"Aalborg - Dänemark",
"Aappilattoq - Greenland",
"Aarhus - Dänemark",
"Aasiaat - Greenland",
"Abashiri - Japan",
"Aberdeen - Vereinigtes Königreich",
"Abidjan - Cote d'Ivoire",
"Abrolhos Islands - Australien",
"Abu Dhabi - UAE",
"Abu Simbel - Ägypten",
"Aburatsu-Nichinan - Japan",
"Abydos - Ägypten",
"Acajutla - El Salvador",
"Acapulco - Mexiko",
"Addu Atoll - Maldives",
"Adelaide - Australien",
"Adele Island - Australien",
"Aden - Yemen",
"Admiralty Island - USA",
"Adria - Italien",
"Aegina Island - Griechenland",
"Aero Island Denmark - Dänemark",
"Agadir - Marokko",
"Agilkia Island - Ägypten",
"Agios Nikolaos - Griechenland",
"Agra - India",
"Agropoli - Italien",
"Aigues-Mortes - Frankreich",
"Airlie Beach - Australien",
"Aitutaki Island - Cook Islands",
"Aix-en-Provence - Frankreich",
"Ajaccio - Frankreich",
"Akaroa - New Zealand",
"Akita City - Japan",
"Akpatok Island - Kanada",
"Akureyri - Island",
"Al Wajh - Saudi Arabia",
"Al-Minya - Ägypten",
"Alaminos - Philippines",
"Alang Ship Breaking Yard - India",
"Alanya - Türkei",
"Albany NY - USA",
"Albany WA - Australien",
"Alcoutim - Portugal",
"Alcudia - Spanien",
"Aldabra Atoll Seychelles - Seychelles",
"Alderney Island - Vereinigtes Königreich",
"Aleria - Frankreich",
"Alert Bay BC - Kanada",
"Alesund - Norwegen",
"Aleutian Islands - USA",
"Alexander Selkirk Island - Chile",
"Alexandria - Ägypten",
"Algeciras - Spanien",
"Alger - Algeria",
"Alghero - Italien",
"Algiers - Algeria",
"Algoma WI - USA",
"Aliaga Ship Breaking Yard - Türkei",
"Alicante - Spanien",
"Aljmas - Kroatien",
"Alken - Deutschland",
"Alkmaar - Niederlande",
"Almeirim - Brasilien",
"Almeria - Spanien",
"Alofi - Niue",
"Alor-Kalabahi - Indonesia",
"Alotau - Papua New Guinea",
"Alpena MI - USA",
"Alphonse Islands Seychelles - Seychelles",
"Alta - Norwegen",
"Alter do Chao - Brasilien",
"Alton IL - USA",
"Amakusa - Japan",
"Amalfi - Italien",
"Amami Oshima Island Japan - Japan",
"Amarapura - Myanmar",
"Amarna - Ägypten",
"Amasra-Bartin - Türkei",
"Ambrym Island - Vanuatu",
"Amelia Island FL - USA",
"Amorgos Island - Griechenland",
"Amrun - Deutschland",
"Amsterdam - Niederlande",
"Amsterdam Island - Norwegen",
"Anaa - French Polynesia",
"Anacortes WA - USA",
"Anadyr - Russia",
"Ancenis - Frankreich",
"Anchorage AK - USA",
"Ancona - Italien",
"Andalsnes - Norwegen",
"Andaman Islands India - India",
"Andenes - Norwegen",
"Andernach - Deutschland",
"Anegada Island BVI - British Virgin Islands",
"Angers - Frankreich",
"Angkor Ban - Cambodia",
"Angra do Heroismo - Portugal",
"Angra dos Reis - Brasilien",
"Anguilla Island - Vereinigtes Königreich",
"Anirnar - Faroe Islands",
"Aniwa Island - Vanuatu",
"Anjouan - Comoros",
"Annaba - Algeria",
"Annapolis MD - USA",
"Antalya - Türkei",
"Antibes - Frankreich",
"Antilla - Cuba",
"Antofagasta - Chile",
"Antsiranana - Madagascar",
"Antwerp - Belgien",
"Anvers Island - Antarctica",
"Aokata - Japan",
"Aomori City - Japan",
"Apia - Samoa",
"Aqaba - Jordan",
"Aran Islands Ireland - Irland",
"Arcachon - Frankreich",
"Arendal - Norwegen",
"Argens Minervois - Frankreich",
"Arica - Chile",
"Aride Island Seychelles - Seychelles",
"Arkhangelsk - Russia",
"Arles - Frankreich",
"Armadale - Vereinigtes Königreich",
"Arnhem - Niederlande",
"Arrecife - Spanien",
"Arromanches-les-Bains - Frankreich",
"Arsivik - Greenland",
"Ascension Island - Vereinigtes Königreich",
"Aschach an der Donau - Austria",
"Aschaffenburg - Deutschland",
"Ashdod - Israel",
"Ashmore Reef - Australien",
"Assumption Island Seychelles - Seychelles",
"Astoria OR - USA",
"Astrakhan - Russia",
"Astrolabe Island - Antarctica",
"Aswan - Ägypten",
"Asyut - Ägypten",
"Atlantis Paradise Island Bahamas - Bahamas",
"Auckland - New Zealand",
"Auckland Island - New Zealand",
"Augusta - Italien",
"Augusta KY - USA",
"Austral Islands - French Polynesia",
"Averoy - Norwegen",
"Avignon - Frankreich",
"Aviles - Spanien",
"Awendaw SC - USA",
"Axel Heiberg Island - Kanada",
"Ayia Napa - Cyprus",
"Ayr - Vereinigtes Königreich",
"Baa Atoll - Maldives",
"Bacharach - Deutschland",
"Bad Breisig - Deutschland",
"Bad Essen - Deutschland",
"Bad Schandau - Deutschland",
"Bad Wimpfen - Deutschland",
"Baddeck NS - Kanada",
"Baden-Baden - Deutschland",
"Baffin Island - Kanada",
"Bagan - Myanmar",
"Bahia Drake - Costa Rica",
"Baie-Comeau - Kanada",
"Bakkargerdi - Island",
"Balestrand - Norwegen",
"Balikpapan - Indonesia",
"Ballycastle - Vereinigtes Königreich",
"Balneario Camboriu - Brasilien",
"Baltimore - USA",
"Baltiysk-Kaliningrad - Russia",
"Baltra Island - Ecuador",
"Bamberg - Deutschland",
"Banda Neira - Indonesia",
"Bandar Abbas - Iran",
"Bandar Seri Begawan - Brunei",
"Bandel - India",
"Bandol - Frankreich",
"Bangaram Island - India",
"Bangkok - Thailand",
"Bangor ME - USA",
"Bangor UK - Vereinigtes Königreich",
"Banjul - Gambia",
"Banks Island - Kanada",
"Bantry - Irland",
"Bar Harbor - USA",
"Bar Montenegro - Montenegro",
"Baranof Island - USA",
"Barbuda Island - Antigua & Barbuda",
"Barca d'Alva - Portugal",
"Barcelona - Spanien",
"Barentsburg - Norwegen",
"Barentsoya Island - Norwegen",
"Bari - Italien",
"Barranquilla Colombia - Kolumbien",
"Barrow AK - USA",
"Bartolome Island - Ecuador",
"Basco-Batan Island - Philippines",
"Basel - Switzerland",
"Basse-Terre - Guadeloupe",
"Basseterre St Kitts - St Kitts & Nevis",
"Bastia - Frankreich",
"Batemans Bay NSW - Australien",
"Bath ME - USA",
"Batina - Kroatien",
"Baton Rouge - USA",
"Batsfjord - Norwegen",
"Battle Harbour NL - Kanada",
"Batumi - Georgia",
"Bay of Islands - New Zealand",
"Bayfield - USA",
"Bayonne - Frankreich",
"Beagle Channel - Chile",
"Bear Islands Russia - Russia",
"Beaufort NC - USA",
"Beaufort SC - USA",
"Beaune - Frankreich",
"Beauty Point-Launceston - Australien",
"Beaver Island - USA",
"Beechey Island - Kanada",
"Beijing - China",
"Beilstein-Mosel - Deutschland",
"Beirut - Lebanon",
"Bejaia - Algeria",
"Belawan-Medan - Indonesia",
"Belem - Brasilien",
"Belfast - Vereinigtes Königreich",
"Belfast ME - USA",
"Belgrade - Serbia",
"Belize City - Belize",
"Belle-Ile-en-Mer - Frankreich",
"Belleville-sur-Saone - Frankreich",
"Bellingham - USA",
"Ben Tre City - Vietnam",
"Beni Suef - Ägypten",
"Benidorm - Spanien",
"Benoa - Indonesia",
"Beppu - Japan",
"Beqa Island Fiji - Fiji",
"Bequia Island - St Vincent & Grenadines",
"Bergen - Norwegen",
"Bering Island - Russia",
"Berlevag - Norwegen",
"Bernkastel-Kues - Deutschland",
"Besancon - Frankreich",
"Bessaker - Norwegen",
"Bezdan - Serbia",
"Bhamo - Myanmar",
"Biarritz - Frankreich",
"Big Diomede Island - Russia",
"Bigge Island WA - Australien",
"Bilbao - Spanien",
"Bimini Islands - Bahamas",
"Bingen am Rhein - Deutschland",
"Bintulu - Malaysia",
"Binz-Rugen - Deutschland",
"Bitetos - Portugal",
"Bitung - Indonesia",
"Bizerte - Tunisia",
"Bjornoya-Bear Island - Norwegen",
"Blanquilla Island - Venezuela",
"Blaye - Frankreich",
"Bleckede - Deutschland",
"Bleiksoya Island - Norwegen",
"Block Island RI - USA",
"Bluff NZ - New Zealand",
"Boa Vista Island - Cape Verde",
"Boca da Valeria - Brasilien",
"Bocas del Toro - Panama",
"Bodo - Norwegen",
"Bodrum - Türkei",
"Bohol Island - Philippines",
"Bolama - Guinea-Bissau",
"Bolgar - Russia",
"Bolungarvik - Island",
"Bom Bom Island - Sao Tome & Principe",
"Bonaventure Island - Kanada",
"Bonifacio - Frankreich",
"Bonn - Deutschland",
"Boothbay Harbor ME - USA",
"Boppard - Deutschland",
"Bora Bora Island - French Polynesia",
"Boracay Island - Philippines",
"Bordeaux - Frankreich",
"Borgholm - Schweden",
"Borkum Island - Deutschland",
"Bornholm Island Denmark - Dänemark",
"Bosaro - Italien",
"Boston - USA",
"Bouchemaine - Frankreich",
"Bougainville Island PNG - Papua New Guinea",
"Boulogne-sur-Mer - Frankreich",
"Bourg-sur-Gironde - Frankreich",
"Bozcaada Island - Türkei",
"Brabant Island - Antarctica",
"Brac Island Croatia - Kroatien",
"Braila - Romania",
"Brandenburg an der Havel - Deutschland",
"Brandenburg KY - USA",
"Brandys nad Labem-Stara Boleslav - Czech Rep",
"Bratislava - Slovakia",
"Braubach - Deutschland",
"Brava Island - Cape Verde",
"Breisach am Rhein - Deutschland",
"Bremen - Deutschland",
"Bremer Island - Australien",
"Bremerhaven - Deutschland",
"Bremerton WA - USA",
"Brest - Frankreich",
"Briare - Frankreich",
"Bridgetown - Barbados",
"Brindisi - Italien",
"Brisbane - Brisbane International Cruise Terminal - Australien",
"Brisbane - Portside Wharf - Australien",
"Bristol RI - USA",
"Bristol UK - Vereinigtes Königreich",
"Brockville - Kanada",
"Bronnoysund - Norwegen",
"Broome WA - Australien",
"Brown Bluff - Antarctica",
"Brunswick GA - USA",
"Bruny Island Tasmania - Australien",
"Buccaneer Archipelago - Australien",
"Bucharest - Romania",
"Bucksport ME - USA",
"Buda Island Burma - Myanmar",
"Budapest - Hungary",
"Buenaventura Colombia - Kolumbien",
"Buenos Aires - Argentinien",
"Bunbury WA - Australien",
"Burbank WA - USA",
"Burg bei Magdeburg - Deutschland",
"Burgas - Bulgaria",
"Burlington IA - USA",
"Burnie - Australien",
"Burnside - USA",
"Busan - Korea",
"Busselton WA - Australien",
"Busuanga Island - Philippines",
"Buzios - Brasilien",
"Bylot Island - Kanada",
"Cabo Frio - Brasilien",
"Cabo Pulmo Beach Resort - Mexiko",
"Cabo Rojo - Dominican Rep",
"Cabo San Lucas - Mexiko",
"Cabrits Dominica - Dominica",
"Cadillac - Frankreich",
"Cadiz - Spanien",
"Caen - Frankreich",
"Caen-Ouistreham - Frankreich",
"Cagliari - Italien",
"Cai Be - Vietnam",
"Cairns - Australien",
"Cais da Lixa - Portugal",
"Calais - Frankreich",
"Caldas de Aregos - Portugal",
"Caleta Bucanero - Ecuador",
"Caleta Tagus - Ecuador",
"Caleta Tortel - Chile",
"Calica - Mexiko",
"Callao-Lima - Peru",
"Calvi - Frankreich",
"Calvorde - Deutschland",
"Cam Ranh - Vietnam",
"Camaret-sur-Mer - Frankreich",
"Camargue - Frankreich",
"Camas-Washougal WA - USA",
"Cambridge Bay - Kanada",
"Cambridge MD - USA",
"Camden NJ - USA",
"Campbell Island NZ - New Zealand",
"Campeche - Mexiko",
"Canakkale - Türkei",
"Cancun - Mexiko",
"Canda - Italien",
"Cannes - Frankreich",
"Canouan Island - St Vincent & Grenadines",
"Cap-Haitien - Haiti",
"Cape Dorset Island - Kanada",
"Cape Girardeau MO - USA",
"Cape Horn - Chile",
"Cape Liberty Bayonne NJ - USA",
"Cape Town - Südafrika",
"Cape Verde Islands - Cape Verde",
"Cape York - Australien",
"Capri Island - Italien",
"Cardiff - Vereinigtes Königreich",
"Carloforte - Italien",
"Carrara - Italien",
"Carriacou Island - Grenada",
"Cartagena  - Kolumbien",
"Cartagena - Spanien",
"Cartwright NL - Kanada",
"Casablanca - Marokko",
"Casilda - Cuba",
"Cassis - Frankreich",
"Castellammare di Stabia - Italien",
"Castellon de la Plana - Spanien",
"Castine ME - USA",
"Castries - St Lucia",
"Cat Island Bahamas - Bahamas",
"Catalina Island - Dominican Rep",
"Catania - Italien",
"Caticlan Jetty Port - Philippines",
"Catskill NY - USA",
"Cavalaire-sur-Mer - Frankreich",
"Cayenne - Frankreich",
"Cayman Brac Island - Cayman Islands",
"Cayo Largo del Sur Cuba - Cuba",
"Cayo Levantado - Dominican Rep",
"Cayo Rico Cuba - Cuba",
"Cebu City - Philippines",
"Cefalu - Italien",
"Celebration Key - Bahamas",
"Celukan Bawang - Indonesia",
"Cernavoda - Romania",
"Cesme - Türkei",
"Cetate - Romania",
"Ceuta - Spanien",
"Chalon-sur-Saone - Frankreich",
"Chalonnes-sur-Loire - Frankreich",
"Champ Island - Russia",
"Champagne Bay - Vanuatu",
"Champasak - Laos",
"Champion Island - Ecuador",
"Chan May - Vietnam",
"Chanaral Island - Chile",
"Chandannagar - India",
"Chania - Griechenland",
"Charleston SC - USA",
"Charlestown Nevis - St Kitts & Nevis",
"Charlotteville - Trinidad & Tobago",
"Chateau de La Roche-Guyon - Frankreich",
"Chateau Thierry - Frankreich",
"Chateauneuf du Pape - Frankreich",
"Chateauneuf-du-Rhone - Frankreich",
"Chatham - Vereinigtes Königreich",
"Chattanooga TN - USA",
"Chau Doc - Vietnam",
"Cheboksary - Russia",
"Chengdu - China",
"Chennai - India",
"Cherbourg - Frankreich",
"Chester IL - USA",
"Chiang Khong - Thailand",
"Chicago - USA",
"Chichagof Island - USA",
"Chichijima Island Japan - Japan",
"Chilean Fjords - Chile",
"Chiloe Island - Chile",
"Chinese Hat Island - Ecuador",
"Chioggia - Italien",
"Chios Island - Griechenland",
"Chiswell Islands Alaska - USA",
"Chittagong Ship Breaking Yard - Bangladesh",
"Cho Gao - Vietnam",
"Chobe National Park - Botswana",
"Chongqing - China",
"Christmas Island - Australien",
"Chukotka Peninsula - Russia",
"Churchill - Kanada",
"Churchill MB - Kanada",
"Cienfuegos - Cuba",
"Cierva Cove - Antarctica",
"Cies Islands - Spanien",
"Cincinnati OH - USA",
"Ciutadella - Spanien",
"Civitavecchia-Rome - Italien",
"Clarkston WA - USA",
"Clarksville TN - USA",
"Clayton NY - USA",
"Cleveland OH - USA",
"Clinton IA - USA",
"Cobh-Cork - Irland",
"Coburg Island - Kanada",
"Coche Island - Venezuela",
"Cochem - Deutschland",
"Cochin - India",
"Coco Cay - Bahamas",
"Cognac - Frankreich",
"Coiba Island Panama - Panama",
"College Fjord - USA",
"Collioure - Frankreich",
"Collonges-au-Mont-d'Or - Frankreich",
"Collonges-la-Rouge - Frankreich",
"Colmar - Frankreich",
"Cologne - Deutschland",
"Colombo - Sri Lanka",
"Colon - Panama",
"Columbus KY - USA",
"Commander Islands Russia - Russia",
"Como - Italien",
"Concarneau - Frankreich",
"Conflans-Sainte-Honorine - Frankreich",
"Conflict Islands PNG - Papua New Guinea",
"Constanta - Romania",
"Cooktown QLD - Australien",
"Copenhagen - Dänemark",
"Coquimbo - Chile",
"Cordoba - Spanien",
"Cordova AK - USA",
"Corfu Island - Griechenland",
"Corigliano Calabro - Italien",
"Corinth - Griechenland",
"Corinth Canal - Griechenland",
"Corinto - Nicaragua",
"Corn Islands Nicaragua - Nicaragua",
"Corner Brook NL - Kanada",
"Cornwall ON - Kanada",
"Cornwallis Island - Kanada",
"Corpach - Vereinigtes Königreich",
"Corral - Chile",
"Cosmoledo Atoll Seychelles - Seychelles",
"Costa Maya - Mexiko",
"Cote d'Azur - Frankreich",
"Cotonou - Benin",
"Cours-les-Barres - Frankreich",
"Cousin Island Seychelles - Seychelles",
"Covenas Colombia - Kolumbien",
"Cozumel - Mexiko",
"Craignure - Vereinigtes Königreich",
"Craobh Haven - Vereinigtes Königreich",
"Cres Island Croatia - Kroatien",
"Crinan - Vereinigtes Königreich",
"Crisan - Romania",
"Crisfield MD - USA",
"Crotone - Italien",
"Cu Lao Gieng Island Vietnam - Vietnam",
"Cubzac-les-Ponts - Frankreich",
"Culebra - Costa Rica",
"Culebra Island - Puerto Rico",
"Culion Island - Philippines",
"Curieuse Island Seychelles - Seychelles",
"Currimao - Philippines",
"Cusco-Machu Picchu - Peru",
"Cuverville Island - Antarctica",
"Cuxhaven - Deutschland",
"Da Nang - Vietnam",
"Dakar - Senegal",
"Dakhla - Marokko",
"Dalian - China",
"Dalyan - Türkei",
"Dammam - Saudi Arabia",
"Danco Island - Antarctica",
"Dangriga - Belize",
"Danubyu - Myanmar",
"Daphne Island - Ecuador",
"Dar es Salaam - Tanzania",
"Dark Island NY - USA",
"Darrow LA - USA",
"Dartmouth - Vereinigtes Königreich",
"Darwin - Australien",
"Davenport IA - USA",
"Decatur AL - USA",
"Deception Island - Antarctica",
"Decin - Czech Rep",
"Deggendorf - Deutschland",
"Delfzijl - Niederlande",
"Delos Island - Griechenland",
"Den Helder - Niederlande",
"Dendera - Ägypten",
"Denia - Spanien",
"Derna - Libya",
"Deshaies - Guadeloupe",
"Desroches Island Seychelles - Seychelles",
"Dessau-Rosslau - Deutschland",
"Detaille Island - Antarctica",
"Detroit MI - USA",
"Deventer - Niederlande",
"Devil Island - Antarctica",
"Devonport Tasmania - Australien",
"Dieppe - Frankreich",
"Dijon - Frankreich",
"Dikili - Türkei",
"Dili - Timor-Leste",
"Dingle-Daingean Ui Chuis - Irland",
"Disney Castaway Cay - Bahamas",
"Disney Lighthouse Point - Bahamas",
"Diu Island - India",
"Djibouti - Djibouti",
"Djupavik - Island",
"Djupivogur - Island",
"Dnipro - Ukraine",
"Dobu Island PNG - Papua New Guinea",
"Doha Qatar - Qatar",
"Doini Island PNG - Papua New Guinea",
"Dole-Jura - Frankreich",
"Donegal - Irland",
"Dongtou - China",
"Donji Milanovac - Serbia",
"Donostia-San Sebastian - Spanien",
"Dordrecht - Niederlande",
"Dormans - Frankreich",
"Dorpen - Deutschland",
"Douarnenez - Frankreich",
"Dover - Vereinigtes Königreich",
"Dover TN - USA",
"Drake Passage - Antarctica",
"Dravuni Island Fiji - Fiji",
"Drawaqa Island Fiji - Fiji",
"Dresden - Deutschland",
"Drobeta-Turnu Severin - Romania",
"Duba-Tabuk - Saudi Arabia",
"Dubai - Dubai Harbour - UAE",
"Dubai - Port Rashid - UAE",
"Dublin - Irland",
"Dubrovnik - Kroatien",
"Dubuque IA - USA",
"Ducie Island - French Polynesia",
"Duclair - Frankreich",
"Duisburg - Deutschland",
"Duluth MN - USA",
"Dun Laoghaire - Irland",
"Dundee - Vereinigtes Königreich",
"Dunedin - New Zealand",
"Dunk Island - Australien",
"Dunkirk - Frankreich",
"Dunmore East - Vereinigtes Königreich",
"Durban - Südafrika",
"Durnstein - Austria",
"Durres - Albania",
"Dusseldorf - Deutschland",
"Dutch Harbor Unalaska - USA",
"Dzaoudzi - Frankreich",
"East London - Südafrika",
"Easter Island Chile - Chile",
"Eastport - USA",
"Eastport ME - USA",
"Ebeltoft - Dänemark",
"Eberbach-Baden - Deutschland",
"Eberswalde - Deutschland",
"Eckernforde - Deutschland",
"Edam-Volendam - Niederlande",
"Eden - Australien",
"Eden Island - Ecuador",
"Edfu - Ägypten",
"Edgeoya Island - Norwegen",
"Eemshaven - Niederlande",
"Egersund - Norwegen",
"Eidfjord - Norwegen",
"Eidsdal - Norwegen",
"Eilat - Israel",
"El Gouna - Ägypten",
"El Guamache - Venezuela",
"El Hierro - Spanien",
"El Puerto de Santa Maria - Spanien",
"Elafonisos Island - Griechenland",
"Elaphiti Islands Croatia - Kroatien",
"Elbow Cay - Bahamas",
"Elcho Island - Australien",
"Elephant Island - Antarctica",
"Elizabeth Bay - Ecuador",
"Ellenz-Poltersdorf - Deutschland",
"Ellesmere Island - Kanada",
"Eltmann - Deutschland",
"Eltville am Rhein - Deutschland",
"Emden - Deutschland",
"Emmerich am Rhein - Deutschland",
"Emmersdorf an der Donau - Austria",
"Ende - Indonesia",
"Enderby Island NZ - New Zealand",
"Endicott Arm Fjord - USA",
"Engelhartszell - Austria",
"Enkhuizen - Niederlande",
"Ensenada - Mexiko",
"Enterprise Island - Antarctica",
"Entre-os-Rios - Portugal",
"Epernay - Frankreich",
"Eresfjord - Norwegen",
"Erie PA - USA",
"Erlangen - Deutschland",
"Esbjerg - Dänemark",
"Escanaba MI - USA",
"Eskifjordur - Island",
"Esmeraldas - Ecuador",
"Esna - Ägypten",
"Espanola Island - Ecuador",
"Esperance WA - Australien",
"Esztergom - Hungary",
"Etretat - Frankreich",
"Eureka CA - USA",
"Evansville IN - USA",
"Exmouth WA - Australien",
"Exuma Islands - Bahamas",
"Faaborg - Dänemark",
"Fair Isle - Vereinigtes Königreich",
"Fairlie - Vereinigtes Königreich",
"Fakarava Atoll - French Polynesia",
"Falkenberg - Schweden",
"Falkland Islands - Vereinigtes Königreich",
"Fall River - USA",
"Falmouth Antigua - Antigua & Barbuda",
"Falmouth Jamaica - Jamaica",
"Falmouth MA - USA",
"Falmouth UK - Vereinigtes Königreich",
"Fanning Island - Kiribati",
"Farquhar Atoll Seychelles - Seychelles",
"Farsund - Norwegen",
"Fatu Hiva Island - French Polynesia",
"Feodosiya - Russia",
"Fergusson Island PNG - Papua New Guinea",
"Fernandina Island - Ecuador",
"Ferradosa - Portugal",
"Ferrol - Spanien",
"Fetesti - Romania",
"Fethiye - Türkei",
"Fetlar Island - Vereinigtes Königreich",
"Finnsnes - Norwegen",
"Fiordland National Park - New Zealand",
"Fishguard - Vereinigtes Königreich",
"Fiskardo - Griechenland",
"Fitzroy Island - Australien",
"Fjaerland - Norwegen",
"Fjallbacka - Schweden",
"Flam - Norwegen",
"Flateyri - Island",
"Flekkefjord - Norwegen",
"Flensburg - Deutschland",
"Floreana Island - Ecuador",
"Florence AL - USA",
"Flores Island Azores - Portugal",
"Floro - Norwegen",
"Fogo Island - Cape Verde",
"Folegandros Island - Griechenland",
"Folgosa - Portugal",
"Fords Terror - USA",
"Forlandet Island - Norwegen",
"Formentera Island - Spanien",
"Forsand - Norwegen",
"Fort Augustus - Vereinigtes Königreich",
"Fort Lauderdale - USA",
"Fort Madison IA - USA",
"Fort Myers Beach FL - USA",
"Fort William - Vereinigtes Königreich",
"Fort-de-France - Martinique",
"Fortaleza - Brasilien",
"Foula Island - Vereinigtes Königreich",
"Fowey - Vereinigtes Königreich",
"Foynes - Irland",
"Frankfurt am Main - Deutschland",
"Frankfurt an der Oder - Deutschland",
"Franz Josef Land - Russia",
"Fraser Island - Australien",
"Fraserburgh - Vereinigtes Königreich",
"Fredericia - Dänemark",
"Frederikshavn - Dänemark",
"Fredrikstad - Norwegen",
"Freeport - Bahamas",
"Freetown - Sierra Leone",
"Fremantle - Australien",
"Freudenberg am Main - Deutschland",
"Friday Harbor WA - USA",
"Fujairah - UAE",
"Fulaga - Fiji",
"Funafuti Tuvalu - Tuvalu",
"Funchal - Portugal",
"Gabes - Tunisia",
"Gadani Ship Breaking Yard - Pakistan",
"Gaeta - Italien",
"Galapagos Islands - Ecuador",
"Galati - Romania",
"Galle - Sri Lanka",
"Gallician - Frankreich",
"Gallipoli - Italien",
"Galveston - USA",
"Galway - Irland",
"Gamagori - Japan",
"Gambier Islands - French Polynesia",
"Gambsheim - Frankreich",
"Gananoque ON - Kanada",
"Garden Island WA - Australien",
"Gaspe - Kanada",
"Gatun Lake Panama Canal - Panama",
"Gdynia-Gdansk - Polen",
"Geelong - Australien",
"Geiranger - Norwegen",
"Gemlik - Türkei",
"Gengenbach - Deutschland",
"Genua - Italien",
"Genovesa Island - Ecuador",
"Genthin - Deutschland",
"George Town - Grand Cayman Island",
"Geraldton - Australien",
"Gerlachshausen - Deutschland",
"Germersheim - Deutschland",
"Gernsheim - Deutschland",
"Ghent - Belgien",
"Giardini Naxos-Taormina - Italien",
"Gibraltar - Vereinigtes Königreich",
"Gijon - Spanien",
"Gili Bidara Island - Indonesia",
"Gili Genting Island - Indonesia",
"Gili Kondo Island - Indonesia",
"Gili Sudak Island - Indonesia",
"Gili Trawangan Island - Indonesia",
"Gironde Estuary - Frankreich",
"Girvan - Vereinigtes Königreich",
"Gisborne - New Zealand",
"Giurgiu - Romania",
"Giurgiulesti - Moldova",
"Giverny - Frankreich",
"Gizo - Solomon Islands",
"Glacier Bay - USA",
"Gladstone QLD - Australien",
"Glengarriff - Irland",
"Gloucester MA - USA",
"Golfito - Costa Rica",
"Golfo Aranci - Italien",
"Golfo Dulce - Costa Rica",
"Golubac - Serbia",
"Goodenough Island PNG - Papua New Guinea",
"Gorinchem - Niederlande",
"Goritsy - Russia",
"Goteborg - Schweden",
"Gouda - Niederlande",
"Gough Island - Vereinigtes Königreich",
"Gozo Island - Malta",
"Graciosa Island Azores - Portugal",
"Grafton IL - USA",
"Grand Cayman Island - Cayman Islands",
"Grand Turk Island - Turks & Caicos Isl",
"Grande Soeur Island Seychelles - Seychelles",
"Great Barrier Island NZ - New Zealand",
"Great Barrier Reef - Australien",
"Great Cumbrae Island - Vereinigtes Königreich",
"Great Guana Cay - Bahamas",
"Great Harbour Cay Bahamas - Bahamas",
"Great Lakes - USA",
"Great Stirrup Cay - Bahamas",
"Great Yarmouth - Vereinigtes Königreich",
"Green Bay WI - USA",
"Green Cove Springs FL - USA",
"Green Turtle Cay - Bahamas",
"Greenock-Glasgow - Vereinigtes Königreich",
"Greenville MS - USA",
"Greenwich Island - Antarctica",
"Greifswald - Deutschland",
"Grein - Austria",
"Grevenmacher - Luxembourg",
"Grimsey Island - Island",
"Groix Island France - Frankreich",
"Groningen - Niederlande",
"Grundarfjordur - Island",
"Grundsund - Schweden",
"Grytviken - Vereinigtes Königreich",
"Guam Island USA - USA",
"Guanaja Island - Honduras",
"Guayaquil - Ecuador",
"Guaymas - Mexiko",
"Gudvangen - Norwegen",
"Guernsey Island - Vereinigtes Königreich",
"Guilin - China",
"Gustavia St Barths - Frankreich",
"Guy Fawkes Island - Ecuador",
"Gythion - Griechenland",
"Haa Alif Atoll - Maldives",
"Haarlem - Niederlande",
"Hachijojima Island Japan - Japan",
"Hachinohe - Japan",
"Hafnarfjordur - Island",
"Hagi - Japan",
"Hai Phong - Vietnam",
"Haida Gwaii Islands - Kanada",
"Haifa - Israel",
"Haikou - China",
"Hainburg an der Donau - Austria",
"Haines - USA",
"Hakata-Fukuoka City - Japan",
"Hakodate - Japan",
"Half Moon Cay - Bahamas",
"Half Moon Island - Antarctica",
"Halifax - Kanada",
"Halki Island - Griechenland",
"Halong Bay - Vietnam",
"Hamad - Qatar",
"Hambantota - Sri Lanka",
"Hamburg - Deutschland",
"Hamilton - Bermuda",
"Hamilton Island QLD - Australien",
"Hamina - Finnland",
"Hammerfest - Norwegen",
"Handa island Scotland - Vereinigtes Königreich",
"Hannibal MO - USA",
"Hannover - Deutschland",
"Hapatoni - French Polynesia",
"Happy Valley-Goose Bay NL - Kanada",
"Harbaria - Bangladesh",
"Harbour Island Bahamas - Bahamas",
"Harlingen - Niederlande",
"Harnosand - Schweden",
"Harsova - Romania",
"Harstad - Norwegen",
"Harvest Caye Belize - Belize",
"Harwich - Vereinigtes Königreich",
"Hasselt - Belgien",
"Haugesund - Norwegen",
"Havana - Cuba",
"Havana IL - USA",
"Havelberg - Deutschland",
"Havoysund - Norwegen",
"Havre-Saint-Pierre - Kanada",
"Heidelberg - Deutschland",
"Heilbronn - Deutschland",
"Heimaey Island - Island",
"Helena-West Helena - USA",
"Heligoland Island Germany - Deutschland",
"Hellesylt - Norwegen",
"Helsingborg - Schweden",
"Helsingor - Dänemark",
"Helsinki - Finnland",
"Helsinki-Vuosaari - Finnland",
"Hendaye - Frankreich",
"Henderson KY - USA",
"Heraklion - Griechenland",
"Heringsdorf-Usedom - Deutschland",
"Herm Island - Vereinigtes Königreich",
"Herradura - Costa Rica",
"Herry - Frankreich",
"Herschel Island - Kanada",
"Hessigheim - Deutschland",
"Heusden - Niederlande",
"Hiddensee Island - Deutschland",
"Hilo - USA",
"Hilpoltstein - Deutschland",
"Hilton Head Island SC - USA",
"Himeji - Japan",
"Hinchinbrook Island - Australien",
"Hiroshima City - Japan",
"Hirschhorn-Neckar - Deutschland",
"Hirtshals - Dänemark",
"Hitachinaka - Japan",
"Hitzacker - Deutschland",
"Hiva Oa Island - French Polynesia",
"Hjorundfjord - Norwegen",
"Ho Chi Minh - Vietnam",
"Hobart - Australien",
"Hochfelden - Frankreich",
"Hofsos - Island",
"Hohensaaten - Deutschland",
"Hoi An - Vietnam",
"Holland MI - USA",
"Holmon - Schweden",
"Holy Island - Vereinigtes Königreich",
"Holy Loch - Vereinigtes Königreich",
"Holyhead - Vereinigtes Königreich",
"Homer AK - USA",
"Honfleur - Frankreich",
"Hong Kong - China",
"Hong Ngu - Vietnam",
"Honiara - Solomon Islands",
"Honningsvag - Norwegen",
"Honolulu - USA",
"Hooker Island - Russia",
"Hoorn - Niederlande",
"Hopedale NL - Kanada",
"Horin - Czech Rep",
"Hornafjordur - Island",
"Horseshoe Island - Antarctica",
"Horta - Portugal",
"Hososhima - Japan",
"Houghton MI - USA",
"Houmas House Plantation - USA",
"Houston - USA",
"Hoya-Weser - Deutschland",
"Hrisey Island - Island",
"Huahine Island - French Polynesia",
"Hualien - Taiwan",
"Huatulco - Mexiko",
"Hubbard Glacier - USA",
"Huelva - Spanien",
"Hull - Vereinigtes Königreich",
"Hundested - Dänemark",
"Huntington WV - USA",
"Hurghada - Ägypten",
"Husavik - Island",
"Hvalsey - Greenland",
"Hvar Island Croatia - Kroatien",
"Hyannis-Barnstable MA - USA",
"Hyde Park NY - USA",
"Hydra Island - Griechenland",
"Ibiza - Spanien",
"Icy Strait Point - USA",
"Igoumenitsa - Griechenland",
"IJmuiden - Niederlande",
"Ikaria Island - Griechenland",
"Ile Rousse - Frankreich",
"Ile-d'Aix Island - Frankreich",
"Iles des Saintes - Guadeloupe",
"Iles du Salut - Frankreich",
"Ilfracombe - Vereinigtes Königreich",
"Ilha Grande - Brasilien",
"Ilhabela - Brasilien",
"Ilheus - Brasilien",
"Ilok - Kroatien",
"Ilulissat - Greenland",
"Inaccessible Island - Vereinigtes Königreich",
"Inagua Island Bahamas - Bahamas",
"Incheon - Korea",
"Inhaca Island - Mozambique",
"Invercargill NZ - New Zealand",
"Invergordon - Vereinigtes Königreich",
"Inverie - Vereinigtes Königreich",
"Inverness - Vereinigtes Königreich",
"Inwa - Myanmar",
"Ios Island - Griechenland",
"Iqaluit - Kanada",
"Iqaluktuuttiaq (Cambridge Bay) - Kanada",
"Iquique - Chile",
"Iquitos - Peru",
"Iron Gate - Serbia",
"Isabela Island - Ecuador",
"Isafjordur - Island",
"Ischia Island - Italien",
"Ishigakijima Island - Japan",
"Ishinomaki - Japan",
"Isla Danzante - Mexiko",
"Isla de la Juventud - Cuba",
"Isla de la Plata Ecuador - Ecuador",
"Isla de los Estados Argentina - Argentinien",
"Isla del Carmen Mexico - Mexiko",
"Isla del Rey Panama - Panama",
"Isla Espiritu Santo - Mexiko",
"Isla Gamez Panama - Panama",
"Isla la Partida - Mexiko",
"Isla Magdalena Chile - Chile",
"Isla Flamenco (Balboa), Panama",
"Isla Monserrate - Mexiko",
"Isla Mujeres Mexico - Mexiko",
"Isla Pacheca - Panama",
"Isla Parida Panama - Panama",
"Isla San Francisco - Mexiko",
"Isla San Jose - Mexiko",
"Isle of Arran - Vereinigtes Königreich",
"Isle of Barra - Vereinigtes Königreich",
"Isle of Bute - Vereinigtes Königreich",
"Isle of Canna - Vereinigtes Königreich",
"Isle of Coll - Vereinigtes Königreich",
"Isle of Colonsay - Vereinigtes Königreich",
"Isle of Eigg - Vereinigtes Königreich",
"Isle of Eriskay - Vereinigtes Königreich",
"Isle of Gigha - Vereinigtes Königreich",
"Isle of Iona - Vereinigtes Königreich",
"Isle of Islay - Vereinigtes Königreich",
"Isle of Jura - Vereinigtes Königreich",
"Isle of Man - Isle of Man",
"Isle of Mingulay - Vereinigtes Königreich",
"Isle of Muck - Vereinigtes Königreich",
"Isle of Mull - Vereinigtes Königreich",
"Isle of Noss - Vereinigtes Königreich",
"Isle of Pines - New Caledonia",
"Isle of Portland - Vereinigtes Königreich",
"Isle of Raasay - Vereinigtes Königreich",
"Isle of Rum - Vereinigtes Königreich",
"Isle of Skye - Vereinigtes Königreich",
"Isle of Staffa - Vereinigtes Königreich",
"Isle of Tiree - Vereinigtes Königreich",
"Isle of Wight - Vereinigtes Königreich",
"Istanbul - Türkei",
"Itajai - Brasilien",
"Itea - Griechenland",
"Ithaca Island - Griechenland",
"Itsukushima Island Japan - Japan",
"Ittoqqortoormiit - Greenland",
"Iwakuni - Japan",
"Ixtapa-Zihuatanejo - Mexiko",
"Izmail - Ukraine",
"Izmir - Türkei",
"Jacksonville - USA",
"Jaco Island - Timor-Leste",
"Jacquinot Bay - Papua New Guinea",
"Jaipur - India",
"Jakarta - Indonesia",
"James Ross Island - Antarctica",
"Jan Mayen Island - Norwegen",
"Jayapura - Indonesia",
"Jeddah - Saudi Arabia",
"Jeju Island - Korea",
"Jekyll Island GA - USA",
"Jersey Island - Vereinigtes Königreich",
"Jiangyin - China",
"Jingzhou - China",
"Jizan - Saudi Arabia",
"Jondal - Norwegen",
"Jost Van Dyke Island BVI - British Virgin Islands",
"Juneau - USA",
"Kadavu - Fiji",
"Kagoshima - Japan",
"Kagoshima City - Japan",
"Kahului - USA",
"Kaikoura - New Zealand",
"Kailua-Kona - USA",
"Kaiteriteri NZ - New Zealand",
"Kalama WA - USA",
"Kalamata - Griechenland",
"Kalmar - Schweden",
"Kalna - India",
"Kalocsa - Hungary",
"Kalundborg - Dänemark",
"Kalvag - Norwegen",
"Kalymnos Island - Griechenland",
"Kamchatka Peninsula - Russia",
"Kamikoshiki-jima - Japan",
"Kampen - Niederlande",
"Kampong Cham - Cambodia",
"Kampong Chhnang - Cambodia",
"Kampong Tralach - Cambodia",
"Kampot - Cambodia",
"Kanazawa - Japan",
"Kangaamiut - Greenland",
"Kangaroo Island - Australien",
"Kangerluluk - Greenland",
"Kangerlussuaq - Greenland",
"Kaniv - Ukraine",
"Kanton Island - Kiribati",
"Kaohsiung - Taiwan",
"Kapellskar - Schweden",
"Karachi - Pakistan",
"Karaikal - India",
"Karatsu - Japan",
"Karimunjawa Islands Indonesia - Indonesia",
"Karlskrona - Schweden",
"Karlsruhe - Deutschland",
"Karlstadt am Main - Deutschland",
"Karpathos Island - Griechenland",
"Kas - Türkei",
"Kasane - Botswana",
"Kastellorizo Island - Griechenland",
"Katakolon - Griechenland",
"Katha - Myanmar",
"Kaunakakai - USA",
"Kavala - Griechenland",
"Kawaihae Harbor - USA",
"Kawthaung - Myanmar",
"Kazan - Russia",
"Kea Island - Griechenland",
"Keelung - Taiwan",
"Kefalonia Island - Griechenland",
"Kehl-Strasbourg - Deutschland",
"Kekova Island - Türkei",
"Kelheim - Deutschland",
"Kemi - Finnland",
"Kepez - Türkei",
"Kerch - Russia",
"Ketchikan - USA",
"Keukenhof Gardens-Lisse - Niederlande",
"Key Biscayne FL - USA",
"Key West - USA",
"Khasab - Oman",
"Kherson - Ukraine",
"Khor Fakkan - UAE",
"Kiel - Deutschland",
"Kiev - Ukraine",
"Killarney ON - Kanada",
"Killybegs - Irland",
"Kimberley Coast - Australien",
"Kimmswick MO - USA",
"Kimolos Island - Griechenland",
"Kinderdijk - Niederlande",
"King Abdullah Port KAEC - Saudi Arabia",
"King George Island - Antarctica",
"King Island Alaska - USA",
"King William Island - Kanada",
"Kings Wharf - Bermuda",
"Kingston Jamaica - Jamaica",
"Kingston NY - USA",
"Kingston ON - Kanada",
"Kinsale - Irland",
"Kirinda - Sri Lanka",
"Kiritimati-Christmas Island - Kiribati",
"Kiriwina Island - Papua New Guinea",
"Kiriwina Island PNG - Papua New Guinea",
"Kirkenes - Norwegen",
"Kirkwall - Vereinigtes Königreich",
"Kitakyushu - Japan",
"Kitava Island PNG - Papua New Guinea",
"Kitty Hawk NC - USA",
"Kitzingen - Deutschland",
"Kizhi Island - Russia",
"Kjollefjord - Norwegen",
"Klaipeda - Lithuania",
"Klaksvik - Faroe Islands",
"Klawock AK - USA",
"Klemtu - Kanada",
"Ko Hong - Thailand",
"Kobe-Osaka - Japan",
"Koblenz - Deutschland",
"Kochi City - Japan",
"Kodiak Island - USA",
"Koh Adang Island Thailand - Thailand",
"Koh Chang Island Thailand - Thailand",
"Koh Chen - Cambodia",
"Koh Hong Island - Thailand",
"Koh Kradan Island Thailand - Thailand",
"Koh Kut-Kood Island Thailand - Thailand",
"Koh Lanta Island Thailand - Thailand",
"Koh Lipe Island Thailand - Thailand",
"Koh Mak Island Thailand - Thailand",
"Koh Muk Island Thailand - Thailand",
"Koh Oknha Tey Island Cambodia - Cambodia",
"Koh Phangan Island Thailand - Thailand",
"Koh Phi Phi Island Thailand - Thailand",
"Koh Rawi Island Thailand - Thailand",
"Koh Rok Nok Island Thailand - Thailand",
"Koh Rong Island Cambodia - Cambodia",
"Koh Samet Island Thailand - Thailand",
"Koh Samui Island Thailand - Thailand",
"Koh Surin - Thailand",
"Koh Tao Island Thailand - Thailand",
"Koh Wua Ta Lap Island Thailand - Thailand",
"Kolkata - India",
"Kollafjorour - Faroe Islands",
"Kom Ombo - Ägypten",
"Komarno - Slovakia",
"Komarom - Hungary",
"Komatsushima - Japan",
"Konigswinter - Deutschland",
"Koper - Slovenia",
"Kopervik - Norwegen",
"Korcula Island Croatia - Kroatien",
"Koror-Palau - USA",
"Korsakov - Russia",
"Kortrijk - Belgien",
"Kos Island - Griechenland",
"Kostolac - Serbia",
"Kostroma - Russia",
"Kota Kinabalu - Malaysia",
"Kotka - Finnland",
"Kotor - Montenegro",
"Krabi - Thailand",
"Kragero - Norwegen",
"Krakatoa Island Indonesia - Indonesia",
"Krakow - Polen",
"Kralendijk Bonaire - Niederlande",
"Kralupy nad Vltavou - Czech Rep",
"Kratie - Cambodia",
"Krefeld - Deutschland",
"Kremenchuk - Ukraine",
"Krems an der Donau - Austria",
"Kristiansand - Norwegen",
"Kristiansund - Norwegen",
"Krk Island Croatia - Kroatien",
"Kuantan - Malaysia",
"Kuching - Malaysia",
"Kuda Bandos Island - Maldives",
"Kuda Finolhu Island - Maldives",
"Kugluktuk - Kanada",
"Kuiu Island - USA",
"Kumano-Mie - Japan",
"Kupang - Indonesia",
"Kupreanof Island - USA",
"Kuri Bay - Australien",
"Kuril Islands - Russia",
"Kusadasi - Türkei",
"Kushiro City - Japan",
"Kuwait City - Kuwait",
"Kuyau Island - Papua New Guinea",
"Kuzino - Russia",
"Kyaikkhami - Myanmar",
"Kyaukmyaung - Myanmar",
"Kyle of Lochalsh - Vereinigtes Königreich",
"Kythira Island - Griechenland",
"Kythnos Island - Griechenland",
"Kyun Daw - Myanmar",
"L'Anse aux Meadows - Kanada",
"La Alcaidesa - Spanien",
"La Ciotat - Frankreich",
"La Coruna - Spanien",
"La Crosse WI - USA",
"La Digue Island Seychelles - Seychelles",
"La Goulette-Tunis - Tunisia",
"La Guaira - Venezuela",
"La Paz - Mexiko",
"La Rochelle - Frankreich",
"La Romana - Dominican Rep",
"La Spezia - Italien",
"La Voulte-sur-Rhone - Frankreich",
"Laamu Atoll - Maldives",
"Laayoune - Marokko",
"Labadee Haiti - Haiti",
"Labuan Bajo - Indonesia",
"Lacepede Islands - Australien",
"Ladbergen - Deutschland",
"Lady Franklin Island - Kanada",
"Laem Chabang - Thailand",
"Laerdalsoyri - Norwegen",
"Lagarde-Moselle - Frankreich",
"Laggan - Vereinigtes Königreich",
"Lagny-sur-Marne - Frankreich",
"Lagos - Portugal",
"Lahaina - USA",
"Lahnstein - Deutschland",
"Lakselv - Norwegen",
"Lamen Bay - Vanuatu",
"Lampi Island Burma - Myanmar",
"Lanai Island - USA",
"Langesund - Norwegen",
"Langlade - Frankreich",
"Langnas Aland - Finnland",
"Larnaca - Cyprus",
"Larne - Vereinigtes Königreich",
"Larvik - Norwegen",
"Las Palmas de Gran Canaria - Spanien",
"Las Tintoreras - Ecuador",
"Lauenburg-Elbe - Deutschland",
"Lauffen am Neckar - Deutschland",
"Lauterbach-Rugen - Deutschland",
"Lautoka - Fiji",
"Lavrion - Griechenland",
"Le Havre-Paris - Frankreich",
"Le Lavandou - Frankreich",
"Le Marin - Martinique",
"Le Pecq - Frankreich",
"Le Pouzin - Frankreich",
"Le Verdon-sur-Mer - Frankreich",
"Leamington - Kanada",
"Leer - Deutschland",
"Lefkada Island - Griechenland",
"Lehnitz-Oranienburg - Deutschland",
"Leiden - Niederlande",
"Leirvik - Faroe Islands",
"Leirvik - Norwegen",
"Leith-Edinburgh - Vereinigtes Königreich",
"Leknes-Gravdal - Norwegen",
"Lelepa Island - Vanuatu",
"Lelystad - Niederlande",
"Lembar - Indonesia",
"Lemmer - Niederlande",
"Lemnos Island - Griechenland",
"Lere - Frankreich",
"Lerici - Italien",
"Leros Island - Griechenland",
"Lerwick - Vereinigtes Königreich",
"Les Andelys - Frankreich",
"Les Anses d'Arlet - Martinique",
"Lesbos Island - Griechenland",
"Lesser Three Gorges - China",
"Levuka - Fiji",
"Lhasa - China",
"Lianyungang - China",
"Libourne - Frankreich",
"Licata - Italien",
"Liege - Belgien",
"Liepaja - Latvia",
"Lifou Island - New Caledonia",
"Lifuka - Tonga",
"Lillesand - Norwegen",
"Limassol - Cyprus",
"Lindos - Griechenland",
"Linz - Austria",
"Linz am Rhein - Deutschland",
"Lipari Island - Italien",
"Lipsi Island - Griechenland",
"Lisbon - Portugal",
"Lismore Island - Vereinigtes Königreich",
"List auf Sylt - Deutschland",
"Litomerice - Czech Rep",
"Little Cayman Island - Cayman Islands",
"Little Cumbrae - Vereinigtes Königreich",
"Little Current - Kanada",
"Little Diomede Island - USA",
"Liverpool - Vereinigtes Königreich",
"Livingston - Guatemala",
"Livingston Island - Antarctica",
"Livorno - Italien",
"Lizard Island QLD - Australien",
"Lobito - Angola",
"Loch Ness - Vereinigtes Königreich",
"Lochmaddy - Vereinigtes Königreich",
"Lodingen - Norwegen",
"Loen - Norwegen",
"Lofoten Islands - Norwegen",
"Lom - Bulgaria",
"Lome-Togo - Togolese Rep",
"London-Greenwich - Vereinigtes Königreich",
"London-Tilbury - Vereinigtes Königreich",
"London-Tower Bridge - Vereinigtes Königreich",
"Londonderry - Vereinigtes Königreich",
"Long Beach - USA",
"Long Island Bahamas - Bahamas",
"Long Khanh Island Vietnam - Vietnam",
"Longyearbyen - Norwegen",
"Loreto - Mexiko",
"Lorient - Frankreich",
"Los Angeles - USA",
"Los Cristianos - Spanien",
"Los Testigos Islands - Venezuela",
"Losinj Island Croatia - Kroatien",
"Louisbourg NS - Kanada",
"Louisville KY - USA",
"Lovango Cay USVI - US Virgin Islands",
"Lovina Beach - Indonesia",
"Lovund Island - Norwegen",
"Luanda - Angola",
"Luang Prabang - Laos",
"Lubeck - Deutschland",
"Luderitz - Namibia",
"Ludwigsburg - Deutschland",
"Ludwigshafen am Rhein - Deutschland",
"Luganville - Vanuatu",
"Lulea - Schweden",
"Lundy Island - Vereinigtes Königreich",
"Lunenburg NS - Kanada",
"Lunga Island - Vereinigtes Königreich",
"Lutherstadt Wittenberg - Deutschland",
"Lutzelbourg - Frankreich",
"Luxembourg City - Luxembourg",
"Luxor - Ägypten",
"Lyngseidet - Norwegen",
"Lyon - Frankreich",
"Lysefjord - Norwegen",
"Lysekil - Schweden",
"Lyttelton-Christchurch - New Zealand",
"Maastricht - Niederlande",
"Macapa - Brasilien",
"Macau - China",
"Maceio - Brasilien",
"Mackinac Island - USA",
"Macleod Island Burma - Myanmar",
"Macon - Frankreich",
"Macquarie Island Tasmania - Australien",
"Madang PNG - Papua New Guinea",
"Madeleine-Magdalen Islands - Kanada",
"Madison IN - USA",
"Madrid - Spanien",
"Magadan - Russia",
"Magdeburg - Deutschland",
"Magong - Taiwan",
"Magway - Myanmar",
"Mahajanga - Madagascar",
"Mahe Island Seychelles - Seychelles",
"Main-Danube Canal - Deutschland",
"Mainz - Deutschland",
"Maio Island - Cape Verde",
"Maizuru-Higashi - Japan",
"Majuro - Marshall Islands",
"Makarska - Kroatien",
"Makaryev Monastery - Russia",
"Makassar - Indonesia",
"Makatea Island - French Polynesia",
"Makkovik NL - Kanada",
"Malacca - Malaysia",
"Malaga - Spanien",
"Malapascua Island - Philippines",
"Male - Maldives",
"Malmo - Schweden",
"Malolo Island Fiji - Fiji",
"Maloy - Norwegen",
"Mamoudzou - Frankreich",
"Man O War Cay - Bahamas",
"Manaus - Brasilien",
"Mancora - Peru",
"Mandal - Norwegen",
"Mandalay - Myanmar",
"Mandrogi - Russia",
"Manfredonia - Italien",
"Mangalore - India",
"Maniitsoq - Greenland",
"Manila - Philippines",
"Mannheim - Deutschland",
"Mannum SA - Australien",
"Manta - Ecuador",
"Mantes-la-Jolie - Frankreich",
"Mantua - Italien",
"Manus Island PNG - Papua New Guinea",
"Manzanillo - Mexiko",
"Maputo - Mozambique",
"Mar del Plata - Argentinien",
"Mare Island - New Caledonia",
"Margarita Island Venezuela - Venezuela",
"Margaux-Cantenac - Frankreich",
"Maria Island Tasmania - Australien",
"Maria la Gorda - Cuba",
"Mariehamn Aland - Finnland",
"Marietta OH - USA",
"Marigot - Frankreich",
"Marin-Pontevedra City - Spanien",
"Marktheidenfeld - Deutschland",
"Marmaris - Türkei",
"Marquette MI - USA",
"Marsala - Italien",
"Marseille - Frankreich",
"Marseille-les-Aubigny - Frankreich",
"Marsh Harbour - Bahamas",
"Marshall Islands - Marshall Islands",
"Marstrand - Schweden",
"Martha's Vineyard Island - USA",
"Martigues - Frankreich",
"Masirah Island - Oman",
"Matacawa Levu Island Fiji - Fiji",
"Matarani - Peru",
"Matsuyama - Japan",
"Matua Island - Russia",
"Maubin - Myanmar",
"Maumere - Indonesia",
"Mayaguez - Puerto Rico",
"Mayapur - India",
"Mayreau Island - St Vincent & Grenadines",
"Maysville KY - USA",
"Mazatlan - Mexiko",
"Meaux - Frankreich",
"Medemblik - Niederlande",
"Meemu Atoll - Maldives",
"Mehamn - Norwegen",
"Mehring - Deutschland",
"Meissen - Deutschland",
"Melbourne - Australien",
"Melilla - Spanien",
"Melk - Austria",
"Melnik - Czech Rep",
"Melun - Frankreich",
"Memphis TN - USA",
"Menetreol-sous-Sancerre - Frankreich",
"Menton - Frankreich",
"Mersin - Türkei",
"Merzig - Deutschland",
"Messina - Italien",
"Methoni - Griechenland",
"Metlakatla - USA",
"Mettlach - Deutschland",
"Metz - Frankreich",
"Miami - USA",
"Middelburg - Niederlande",
"Midland - Kanada",
"Midway Island USA - USA",
"Milano City - Italien",
"Milazzo - Italien",
"Milford Haven - Vereinigtes Königreich",
"Milford Sound - New Zealand",
"Milos Island - Griechenland",
"Miltenberg - Deutschland",
"Milwaukee WI - USA",
"Mina Salman-Manama - Bahrain",
"Mindelo - Cape Verde",
"Minden-Weser - Deutschland",
"Mingun - Myanmar",
"Minhla - Myanmar",
"Minneapolis-Saint Paul - USA",
"Miquelon - Frankreich",
"Misrata - Libya",
"Mitarai - Japan",
"Miyako-Iwate - Japan",
"Miyakojima Island - Japan",
"Miyazaki City - Japan",
"Mlcechvosty-Vranany - Czech Rep",
"Mljet Island Croatia - Kroatien",
"Mo I Rana - Norwegen",
"Mobile - USA",
"Moffen Island - Norwegen",
"Mohacs - Hungary",
"Moheshkhali - Bangladesh",
"Moji Port - Japan",
"Molde - Norwegen",
"Molokai - USA",
"Mombasa - Kenya",
"Monemvasia - Griechenland",
"Monfalcone - Italien",
"Monopoli - Italien",
"Monrovia - Liberia",
"Monte Carlo - Monaco",
"Montebello Islands - Australien",
"Montego Bay - Jamaica",
"Monterey CA - USA",
"Montevideo - Uruguay",
"Montmerle-sur-Saone - Frankreich",
"Montreal - Kanada",
"Montserrat Island UK - Vereinigtes Königreich",
"Monumental Island - Kanada",
"Monuriki Island Fiji - Fiji",
"Monywa - Myanmar",
"Mooloolaba - Australien",
"Moorea Island - French Polynesia",
"Moreton Island - Australien",
"Mormugao - India",
"Mornington Island QLD - Australien",
"Moscow - Russia",
"Mosquera Island - Ecuador",
"Mossel Bay - Südafrika",
"Motihari - India",
"Motobu - Japan",
"Motril - Spanien",
"Mount Vernon VA - USA",
"Mozambique Island - Mozambique",
"MSC Ocean Cay - Bahamas",
"Muhlhausen - Deutschland",
"Mulhouse - Frankreich",
"Mumbai - India",
"Munich - Deutschland",
"Murmansk - Russia",
"Muroran - Japan",
"Murshidabad - India",
"Muscat - Oman",
"Muscatine - USA",
"Muskegon MI - USA",
"My Tho - Vietnam",
"Myanaung - Myanmar",
"Mykonos Island - Griechenland",
"Mystery Island - Vanuatu",
"Mytilene - Griechenland",
"Naantali - Finnland",
"Nafplio - Griechenland",
"Nagasaki City - Japan",
"Nagato - Japan",
"Nagoya - Japan",
"Naha - Japan",
"Nain NL - Kanada",
"Namibe - Angola",
"Namsos - Norwegen",
"Namur - Belgien",
"Nanaimo BC - Kanada",
"Nananu-I-Ra Island Fiji - Fiji",
"Nancy - Frankreich",
"Nanortalik - Greenland",
"Nansha-Guangzhou - China",
"Nantes - Frankreich",
"Nantucket MA - USA",
"Napa CA - USA",
"Napier - New Zealand",
"Naples - Italien",
"Narsaq - Greenland",
"Narsarsuaq - Greenland",
"Narvik - Norwegen",
"Nashville TN - USA",
"Nassau - Bahamas",
"Natal - Brasilien",
"Natchez MS - USA",
"Nauta - Peru",
"Naviti Island Fiji - Fiji",
"Nawiliwili - USA",
"Naxos Island - Griechenland",
"Neapoli - Griechenland",
"Neko Harbour - Antarctica",
"Nelson Island - Antarctica",
"Nelson NZ - New Zealand",
"Nendo - Solomon Islands",
"Nerlerit Inaat - Greenland",
"Neskaupstadur - Island",
"Nesna - Norwegen",
"Nessebar - Bulgaria",
"Neuhofen an der Ybbs - Austria",
"Neum - Bosnia & Herzegovina",
"Nevers - Frankreich",
"New Bedford MA - USA",
"New Delhi - India",
"New Ireland Island PNG - Papua New Guinea",
"New London CT - USA",
"New Madrid MO - USA",
"New Orleans - USA",
"New Plymouth - New Zealand",
"New Siberian Islands - Russia",
"New York - Manhattan - USA",
"New York - Red Hook-Brooklyn - USA",
"Newcastle NSW - Australien",
"Newcastle upon Tyne - Vereinigtes Königreich",
"Newhaven - Vereinigtes Königreich",
"Newport - Vereinigtes Königreich",
"Newport RI - USA",
"Ngapali - Myanmar",
"Nggela Islands - Solomon Islands",
"Nha Trang - Vietnam",
"Nhulunbuy - Australien",
"Nice - Frankreich",
"Niderviller - Frankreich",
"Niebla-Valdivia - Chile",
"Nienburg-Weser - Deutschland",
"Nierstein - Deutschland",
"Nightingale Island - Vereinigtes Königreich",
"Niigata City - Japan",
"Nijmegen - Niederlande",
"Nikopol - Bulgaria",
"Ningbo-Zhoushan - China",
"Nishinoshima Island - Japan",
"Nisyros Island - Griechenland",
"Niuafo ou - Tonga",
"Nizhny Novgorod - Russia",
"Njari Island - Solomon Islands",
"Nome - USA",
"Nordaustlandet Island - Norwegen",
"Nordfjordeid - Norwegen",
"Nordkapp-North Cape - Norwegen",
"Nordvest-Spitsbergen - Norwegen",
"Norfolk Island - Australien",
"Norfolk VA - USA",
"Norman Island BVI - British Virgin Islands",
"North Seymour Island - Ecuador",
"Northwest Passage - Kanada",
"Noshiro - Japan",
"Nosy Be Island - Madagascar",
"Nosy Komba Island - Madagascar",
"Nottoway Plantation - USA",
"Noumea - New Caledonia",
"Novaya Zemlya - Russia",
"Novi Sad - Serbia",
"Novorossiysk - Russia",
"Nuku Hiva Island - French Polynesia",
"Nukualofa - Tonga",
"Nukupule - Tonga",
"Nuremberg - Deutschland",
"Nuuk - Greenland",
"Ny-Alesund - Norwegen",
"Nyborg - Dänemark",
"Nymburk - Czech Rep",
"Nynashamn - Schweden",
"Oak Alley Plantation - USA",
"Oarai - Japan",
"Oban NZ - New Zealand",
"Oban UK - Vereinigtes Königreich",
"Oberammergau - Deutschland",
"Oberwesel - Deutschland",
"Ocho Rios - Jamaica",
"Ochsenfurt - Deutschland",
"Odda - Norwegen",
"Odden - Dänemark",
"Odense - Dänemark",
"Oderberg - Deutschland",
"Odessa - Ukraine",
"Ogi - Japan",
"Oita City - Japan",
"Okayama City - Japan",
"Okhotsk - Russia",
"Okinawa - Japan",
"Oksfjord - Norwegen",
"Olbia - Italien",
"Old Saybrook - USA",
"Olden - Norwegen",
"Oldenburg - Deutschland",
"Oltenita - Romania",
"Omaezaki - Japan",
"Omis - Kroatien",
"Onekotan Island - Russia",
"Onomichi-Itozaki - Japan",
"Opatija - Kroatien",
"Oporto Cais de Gaia - Portugal",
"Oporto Cais de Miragaia - Portugal",
"Oporto Quebrantoes",
"- Portugal",
"Oran - Algeria",
"Oranjestad Aruba - Niederlande",
"Oriahovo - Bulgaria",
"Oristano - Italien",
"Ornes - Norwegen",
"Ornskoldsvik - Schweden",
"Orsova - Romania",
"Ortona - Italien",
"Osijek - Kroatien",
"Oslo - Norwegen",
"Ostend - Belgien",
"Ostiglia - Italien",
"Otranto - Italien",
"Ottawa IL - USA",
"Oudeschild-Texel Island - Niederlande",
"Oudong - Cambodia",
"Ouges - Frankreich",
"Oulu - Finnland",
"Ouranoupoli - Griechenland",
"Ouvea - New Caledonia",
"Owaraha - Solomon Islands",
"Owensboro KY - USA",
"Oxford MD - USA",
"Oye - Norwegen",
"Paamiut - Greenland",
"Padang - Indonesia",
"Padangbai - Indonesia",
"Padua - Italien",
"Paducah KY - USA",
"Pagan Island Marianas - USA",
"Pago Pago - USA",
"Pak Ou Caves - Laos",
"Pakokku - Myanmar",
"Palamos - Spanien",
"Palatka FL - USA",
"Palau - Italien",
"Palavas-les-Flots - Frankreich",
"Palermo - Italien",
"Palma de Mallorca - Spanien",
"Palmarola Island - Italien",
"Palmerston Island - Cook Islands",
"Pan de Azucar Island - Chile",
"Panama Canal - Panama",
"Panama City - Panama",
"Panasesa Island - Papua New Guinea",
"Papeete (Tahiti) - French Polynesia",
"Papenburg - Deutschland",
"Papey - Island",
"Paphos - Cyprus",
"Paradise Harbor - Antarctica",
"Paramaribo - Suriname",
"Paramushir Island - Russia",
"Paranagua - Brasilien",
"Paraty - Brasilien",
"Pare-Pare - Indonesia",
"Parga - Griechenland",
"Parintins - Brasilien",
"Paris City - Frankreich",
"Parnu - Estland",
"Paros Island - Griechenland",
"Parry Sound ON - Kanada",
"Pasaia - Spanien",
"Passau - Deutschland",
"Patmos Island - Griechenland",
"Patong - Thailand",
"Patras - Griechenland",
"Patreksfjordur - Island",
"Pattaya - Thailand",
"Pauillac - Frankreich",
"Paulet Island - Antarctica",
"Paxos Island - Griechenland",
"Pearl Islands Panama - Panama",
"Peenemunde-Usedom - Deutschland",
"Peine - Deutschland",
"Pelorus Island - Australien",
"Pembroke Dock - Vereinigtes Königreich",
"Peniscola - Spanien",
"Pentecost Island - Vanuatu",
"Penzance - Vereinigtes Königreich",
"Peoria IL - USA",
"Perce QC - Kanada",
"Perm - Russia",
"Pesaro - Italien",
"Peter I Island - Norwegen",
"Peter Island BVI - British Virgin Islands",
"Peterhead - Vereinigtes Königreich",
"Petermann Island - Antarctica",
"Petersburg AK - USA",
"Petropavlovsk-Kamchatsky - Russia",
"Philadelphia - USA",
"Philipsburg St Maarten - Niederlande",
"Phillip Island - Australien",
"Philpots Island - Kanada",
"Phnom Penh - Cambodia",
"Phu My - Vietnam",
"Phu Quoc Island Vietnam - Vietnam",
"Phuket - Thailand",
"Pico Island Azores - Portugal",
"Picton - New Zealand",
"Pictou - Kanada",
"Piesport-Mosel - Deutschland",
"Pigeon Island - St Lucia",
"Pingtan - China",
"Pinhao - Portugal",
"Piombino - Italien",
"Piraeus-Athens - Griechenland",
"Piran - Slovenia",
"Pirna - Deutschland",
"Pisco - Peru",
"Pitcairn Island - Vereinigtes Königreich",
"Pittsburgh PA - USA",
"Placencia - Belize",
"Playa Curu - Costa Rica",
"Playa del Carmen - Mexiko",
"Playa Flamingo - Costa Rica",
"Playa Muerto - Panama",
"Playas del Coco - Costa Rica",
"Pleneau Island - Antarctica",
"Ploce - Kroatien",
"Plockton - Vereinigtes Königreich",
"Plymouth MA - USA",
"Plymouth UK - Vereinigtes Königreich",
"Plyos - Russia",
"Pochlarn - Austria",
"Pocinho - Portugal",
"Podebrady - Czech Rep",
"Pohang - Korea",
"Pohnpei Island Micronesia - Micronesia",
"Point Hope - USA",
"Point Pleasant WV - USA",
"Pointe-a-Pitre - Guadeloupe",
"Pointe-Noire - Republic of the Congo",
"Poissy - Frankreich",
"Polesella - Italien",
"Pomene - Mozambique",
"Pommern-Mosel - Deutschland",
"Ponce - Puerto Rico",
"Pond Inlet - Kanada",
"Ponta Delgada - Portugal",
"Ponza Island - Italien",
"Poole - Vereinigtes Königreich",
"Porbandar - India",
"Pori - Finnland",
"Poros Island - Griechenland",
"Porquerolles Island France - Frankreich",
"Port Alberni - Kanada",
"Port Angeles WA - USA",
"Port Antonio - Jamaica",
"Port Arthur - Australien",
"Port Arthur - USA",
"Port Blair - India",
"Port Canaveral - USA",
"Port Colborne ON - Kanada",
"Port Denarau-Nadi - Fiji",
"Port Douglas - Australien",
"Port Elizabeth - Südafrika",
"Port Erin - Isle of Man",
"Port Hedland - Australien",
"Port Kembla - Australien",
"Port Klang - Malaysia",
"Port Lincoln - Australien",
"Port Louis - Mauritius",
"Port Mahon - Spanien",
"Port Moresby - Papua New Guinea",
"Port of Sorong - Indonesia",
"Port Reunion - Reunion",
"Port Royal - Jamaica",
"Port Said - Ägypten",
"Port Stanley - Falkland Islands",
"Port Townsend WA - USA",
"Port Vila - Vanuatu",
"Port-au-Prince - Haiti",
"Port-Joinville - Frankreich",
"Port-of-Spain - Trinidad & Tobago",
"Port-Saint-Louis-du-Rhone - Frankreich",
"Port-Vendres - Frankreich",
"Portimao - Portugal",
"Portland - Australien",
"Portland ME - USA",
"Portland OR - USA",
"Porto Alegre - Brasilien",
"Porto Antigo - Portugal",
"Porto Belo - Brasilien",
"Porto Cervo - Italien",
"Porto Empedocle - Italien",
"Porto Ercole - Italien",
"Porto Levante - Italien",
"Porto Santo Island Madeira - Portugal",
"Porto Santo Stefano - Italien",
"Porto Seguro - Brasilien",
"Porto Torres - Italien",
"Porto Vecchio - Frankreich",
"Porto Venere - Italien",
"Porto-Leixoes - Portugal",
"Portobelo - Panama",
"Portoferraio - Italien",
"Portofino - Italien",
"Portrush - Vereinigtes Königreich",
"Portsmouth Dominica - Dominica",
"Portsmouth UK - Vereinigtes Königreich",
"Portuguese Island - Mozambique",
"Posada - Italien",
"Positano - Italien",
"Potsdam - Deutschland",
"Poulsbo WA - USA",
"Pourquoi Pas Island - Antarctica",
"Pozzallo - Italien",
"Pozzuoli - Italien",
"Prague - Czech Rep",
"Praia - Cape Verde",
"Praia da Vitoria - Portugal",
"Praslin Island Seychelles - Seychelles",
"Prek Bang Kong - Cambodia",
"Preveza - Griechenland",
"Prickly Pear Island - British Virgin Islands",
"Primosten - Kroatien",
"Prince Edward Island - Kanada",
"Prince Leopold Island  - Kanada",
"Prince of Wales Island - Kanada",
"Prince of Wales Island AK - USA",
"Prince Rupert - Kanada",
"Princess Cays - Bahamas",
"Probolinggo - Indonesia",
"Progreso - Mexiko",
"Propriano - Frankreich",
"Providence RI - USA",
"Providencia Island Colombia - Kolumbien",
"Providenciales Island - Turks & Caicos Isl",
"Provideniya - Russia",
"Provincetown MA - USA",
"Puerto Agua Verde - Mexiko",
"Puerto Aguirre - Chile",
"Puerto Banus-Marbella - Spanien",
"Puerto Bolivar - Ecuador",
"Puerto Caldera - Costa Rica",
"Puerto Chacabuco - Chile",
"Puerto Chiapas - Mexiko",
"Puerto Cortes - Honduras",
"Puerto del Rosario - Spanien",
"Puerto Deseado - Argentinien",
"Puerto Dos Bocas - Mexiko",
"Puerto Eden - Chile",
"Puerto Escondido - Mexiko",
"Puerto Gran Tarajal - Spanien",
"Puerto Jimenez - Costa Rica",
"Puerto Limon - Costa Rica",
"Puerto Los Gatos - Mexiko",
"Puerto Madryn - Argentinien",
"Puerto Montt - Chile",
"Puerto Morelos - Mexiko",
"Puerto Natales - Chile",
"Puerto Penasco - Mexiko",
"Puerto Plata-Amber Cove - Dominican Rep",
"Puerto Princesa - Philippines",
"Puerto Quetzal - Guatemala",
"Puerto Vallarta - Mexiko",
"Puerto Williams - Chile",
"Pula - Kroatien",
"Pulau Ambon Island Indonesia - Indonesia",
"Pulau Bangka Island Indonesia - Indonesia",
"Pulau Bawean Island Indonesia - Indonesia",
"Pulau Belitung Island Indonesia - Indonesia",
"Pulau Biak Island Indonesia - Indonesia",
"Pulau Bintan Island Indonesia - Indonesia",
"Pulau Buton Island Indonesia - Indonesia",
"Pulau Flores Island Indonesia - Indonesia",
"Pulau Kabaena Island Indonesia - Indonesia",
"Pulau Komodo Island - Indonesia",
"Pulau Langkawi Island - Malaysia",
"Pulau Lembata Island Indonesia - Indonesia",
"Pulau Madura Island Indonesia - Indonesia",
"Pulau Misool Island Indonesia - Indonesia",
"Pulau Moyo Island Indonesia - Indonesia",
"Pulau Pangkor Island Malaysia - Malaysia",
"Pulau Penang Island - Malaysia",
"Pulau Rinca Island Indonesia - Indonesia",
"Pulau Savu Island Indonesia - Indonesia",
"Pulau Selaru Island Indonesia - Indonesia",
"Pulau Sumba Island Indonesia - Indonesia",
"Pulau Sumbawa Island Indonesia - Indonesia",
"Pulau Ternate Island Indonesia - Indonesia",
"Pulau Tiga Island Malaysia - Malaysia",
"Pulau Tioman Island Malaysia - Malaysia",
"Pulau Weh Island Indonesia - Indonesia",
"Punta Arenas - Chile",
"Punta Cana - Dominican Rep",
"Punta del Este - Uruguay",
"Punta Gorda - Belize",
"Puntarenas - Costa Rica",
"Putuoshan Island China - China",
"Pyay - Myanmar",
"Pylos - Griechenland",
"Pyramiden - Norwegen",
"Qaanaaq - Greenland",
"Qaqortoq - Greenland",
"Qassiarsuk - Greenland",
"Qeqertarsuaq - Greenland",
"Qingdao - China",
"Quebec City - Kanada",
"Queensferry - Vereinigtes Königreich",
"Queenstown NZ - New Zealand",
"Quepos - Costa Rica",
"Quiberon - Frankreich",
"Quito - Ecuador",
"Quy Nhon - Vietnam",
"Rab Island Croatia - Kroatien",
"Rabac - Kroatien",
"Rabaul - Papua New Guinea",
"Rabida Island - Ecuador",
"Raiatea Island - French Polynesia",
"Rainier OR - USA",
"Ralswiek-Rugen - Deutschland",
"Ranchot-Jura - Frankreich",
"Rangiroa Atoll - French Polynesia",
"Rapallo - Italien",
"Raragala Island - Australien",
"Rarotonga Island - Cook Islands",
"Ras Al Khaimah - UAE",
"Rastatt - Deutschland",
"Rathlin Island - Vereinigtes Königreich",
"Raufarhofn - Island",
"Rauma - Finnland",
"Rausu - Japan",
"Ravenna - Italien",
"Recife - Brasilien",
"Red Bay NL - Kanada",
"Red Wing MN - USA",
"Redang Island - Malaysia",
"Regensburg - Deutschland",
"Reggio Calabria - Italien",
"Regua - Portugal",
"Reine - Norwegen",
"Remagen - Deutschland",
"Remich - Luxembourg",
"Rendsburg - Deutschland",
"Resolute Bay - Kanada",
"Resolution Island - Kanada",
"Rethymno - Griechenland",
"Reykjavik - Island",
"Rheinau - Deutschland",
"Rhine Gorge - Deutschland",
"Rhodes Island - Griechenland",
"Richards Bay - Südafrika",
"Richland WA - USA",
"Riga - Latvia",
"Rigolet NL - Kanada",
"Rijeka - Kroatien",
"Rimouski - Kanada",
"Ringaskiddy - Irland",
"Ringgold Isles - Fiji",
"Rio de Janeiro - Brasilien",
"Rio Grande - Brasilien",
"Riol - Deutschland",
"Riposto - Italien",
"Rishiri - Japan",
"Risoyhamn - Norwegen",
"Rives-en-Seine - Frankreich",
"Roatan Island - Honduras",
"Robinson Crusoe Island - Chile",
"Rochester NY - USA",
"Rockland ME - USA",
"Rodrigues Island - Mauritius",
"Roermond - Niederlande",
"Rogeia Island - Papua New Guinea",
"Romblon Island - Philippines",
"Ronnang - Schweden",
"Roquemaure - Frankreich",
"Rorvik - Norwegen",
"Roscoff - Frankreich",
"Rose Island Bahamas - Bahamas",
"Roseau - Dominica",
"Rosedale MS - USA",
"Rosendal - Norwegen",
"Roses - Spanien",
"Ross Island - Antarctica",
"Rosslare Europort - Irland",
"Rostock - Deutschland",
"Rostov-on-Don - Russia",
"Rosyth - Vereinigtes Königreich",
"Rothenburg ob der Tauber - Deutschland",
"Rotterdam - Niederlande",
"Roudnice nad Labem - Czech Rep",
"Rouen - Frankreich",
"Rovigo - Italien",
"Rovinj - Kroatien",
"Royan - Frankreich",
"Roztoky - Czech Rep",
"Rudesheim am Rhein - Deutschland",
"Ruhen-Gifhorn - Deutschland",
"Runavik - Faroe Islands",
"Ruse - Bulgaria",
"Sa Dec - Vietnam",
"Saarbrucken - Deutschland",
"Saarburg - Deutschland",
"Saaremaa Island - Estland",
"Saarlouis - Deutschland",
"Saba Island - Niederlande",
"Sable Island - Kanada",
"Sacramento CA - USA",
"Sadoshima Island Japan - Japan",
"Safaga - Ägypten",
"Safi - Marokko",
"Sag Harbor - USA",
"Sagaing - Myanmar",
"Saguenay - Kanada",
"Saint Helena Island - Vereinigtes Königreich",
"Saint John NB - Kanada",
"Saint Martin's Island - Bangladesh",
"Saint Petersburg - Russia",
"Saint Pierre and Miquelon Islands - Frankreich",
"Saint Vincent Island - St Vincent & Grenadines",
"Saint-Denis - Frankreich",
"Saint-Emilion - Frankreich",
"Saint-Etienne-des-Sorts - Frankreich",
"Saint-Florent - Frankreich",
"Saint-Jean-de-Losne - Frankreich",
"Saint-Jean-de-Luz - Frankreich",
"Saint-Jean-les-Deux-Jumeaux - Frankreich",
"Saint-Leger-sur-Dheune - Frankreich",
"Saint-Malo - Frankreich",
"Saint-Nazaire - Frankreich",
"Saint-Pierre - Martinique",
"Saint-Raphael - Frankreich",
"Saint-Tropez - Frankreich",
"Sainte Anne Island Seychelles - Seychelles",
"Saipan Island Marianas - USA",
"Sakaiminato-Matsue - Japan",
"Sakata - Japan",
"Sakhalin Island - Russia",
"Sal Island - Cape Verde",
"Salalah - Oman",
"Salaverry-Trujillo - Peru",
"Salay - Myanmar",
"Saldanha Harbour - Südafrika",
"Salem - USA",
"Salerno - Italien",
"Salomague-Ilocos - Philippines",
"Salt Cay - Turks & Caicos Isl",
"Salt Island BVI - British Virgin Islands",
"Salvador de Bahia - Brasilien",
"Salzburg - Austria",
"Samana - Dominican Rep",
"Samara - Russia",
"Samarai Island PNG - Papua New Guinea",
"Sami - Griechenland",
"Samos Island - Griechenland",
"Samothraki Island - Griechenland",
"Samsun - Türkei",
"San Andres Island Colombia - Kolumbien",
"San Antonio - Chile",
"San Blas Islands Panama - Panama",
"San Carlos - Mexiko",
"San Cristobal - Ecuador",
"San Cristobal Island - Ecuador",
"San Diego - USA",
"San Francisco - USA",
"San Jose del Cabo - Mexiko",
"San Juan - Puerto Rico",
"San Juan del Sur - Nicaragua",
"San Nicola di Tremiti - Italien",
"San Remo - Italien",
"San Salvador Island Bahamas - Bahamas",
"San Sebastian de la Gomera - Spanien",
"Sanary-sur-Mer - Frankreich",
"Sanda Island - Vereinigtes Königreich",
"Sandakan - Malaysia",
"Sandane - Norwegen",
"Sanday Island - Vereinigtes Königreich",
"Sandefjord - Norwegen",
"Sandnes - Norwegen",
"Sandnessjoen - Norwegen",
"Sankt Goarshausen - Deutschland",
"Santa Barbara CA - USA",
"Santa Catalina Island CA - USA",
"Santa Cruz de la Palma - Spanien",
"Santa Cruz de Tenerife - Spanien",
"Santa Cruz Island - Ecuador",
"Santa Fe Island - Ecuador",
"Santa Margherita Ligure - Italien",
"Santa Maria di Leuca - Italien",
"Santa Maria Island Azores - Portugal",
"Santa Marta Colombia - Kolumbien",
"Santa Rosalia - Mexiko",
"Santander - Spanien",
"Santarem - Brasilien",
"Santiago de Cuba - Cuba",
"Santiago Island - Ecuador",
"Santo Antao Island - Cape Verde",
"Santo Antonio - Sao Tome & Principe",
"Santo Domingo - Dominican Rep",
"Santo Tomas de Castilla - Guatemala",
"Santorini Island - Griechenland",
"Santos - Brasilien",
"Sanya - China",
"Sao Francisco do Sul - Brasilien",
"Sao Jorge Island Azores - Portugal",
"Sao Luis - Brasilien",
"Sao Nicolau Island - Cape Verde",
"Sao Tome Island - Sao Tome & Principe",
"Sapelo Island GA - USA",
"Sapporo-Otaru - Japan",
"Sapporo-Tomakomai - Japan",
"Sarande - Albania",
"Saratov - Russia",
"Sark Island - Vereinigtes Königreich",
"Sasebo - Japan",
"Sassnitz-Rugen - Deutschland",
"Saudarkrokur - Island",
"Sault Ste Marie - Kanada",
"Saunders Island - Falkland Islands",
"Savannah GA - USA",
"Savannah TN - USA",
"Saverne - Frankreich",
"Savona - Italien",
"Savusavu - Fiji",
"Scarborough - Trinidad & Tobago",
"Schoonhoven - Niederlande",
"Schwedt-Oder - Deutschland",
"Schweich - Deutschland",
"Schweinfurt - Deutschland",
"Scrabster - Vereinigtes Königreich",
"Scrub Island BVI - British Virgin Islands",
"Seattle - USA",
"Semarang - Indonesia",
"Sendai - Japan",
"Senggigi - Indonesia",
"Senja Island - Norwegen",
"Seogwipo - Korea",
"Sept-Iles - Kanada",
"Serifos Island - Griechenland",
"Sete - Frankreich",
"Setubal - Portugal",
"Seurre - Frankreich",
"Sevastopol - Russia",
"Severnaya Zemlya - Russia",
"Seville - Spanien",
"Seward - USA",
"Seydisfjordur - Island",
"Sfantu Gheorghe - Romania",
"Shanghai - Shanghai Port - China",
"Shanghai - Waigaoqiao - China",
"Shanghai - Wusongkou - China",
"Shannonbridge - Irland",
"Sharm El Sheikh - Ägypten",
"Shelburne NS - Kanada",
"Shenzhen - China",
"Sherrard Island - Australien",
"Shibaozhai - China",
"Shimizu - Japan",
"Shimo-kamagari - Japan",
"Shimokoshiki-jima - Japan",
"Shimonoseki - Japan",
"Shingu - Japan",
"Shwe Pyi Thar - Myanmar",
"Si Racha - Thailand",
"Sibenik - Kroatien",
"Siem Reap - Cambodia",
"Sifnos Island - Griechenland",
"Siglufjordur - Island",
"Sihanoukville - Cambodia",
"Silhouette Island Seychelles - Seychelles",
"Silistra - Bulgaria",
"Silver Islet - Kanada",
"Similan Islands Thailand - Thailand",
"Singapore-Harbourfront - Singapore",
"Singapore-Marina Bay - Singapore",
"Sinop - Türkei",
"Sir Bani Yas Island - UAE",
"Siracusa - Italien",
"Sisak - Kroatien",
"Sisimiut - Greenland",
"Sitka - USA",
"Skagen - Dänemark",
"Skagway - USA",
"Skarsvag - Norwegen",
"Skiathos Island - Griechenland",
"Skikda - Algeria",
"Skjervoy - Norwegen",
"Skjolden - Norwegen",
"Skjoldungen Island Greenland - Greenland",
"Skomer Island - Vereinigtes Königreich",
"Skopelos Island - Griechenland",
"Skyros Island - Griechenland",
"Slano - Kroatien",
"Slavonski Brod - Kroatien",
"Sleepy Hollow NY - USA",
"Smogen - Schweden",
"Snares Islands NZ - New Zealand",
"Sneek - Niederlande",
"Snow Hill Island - Antarctica",
"Sochi - Russia",
"Sokcho - Korea",
"Sokhna - Ägypten",
"Soller-Mallorca - Spanien",
"Solomon Islands - Solomon Islands",
"Solovetsky Islands - Russia",
"Solt - Hungary",
"Somerset Island - Kanada",
"Sommaroy Island - Norwegen",
"Sopers Hole BVI - British Virgin Islands",
"Sor-Spitsbergen - Norwegen",
"Sorrento - Italien",
"Sortavala - Russia",
"Sortland - Norwegen",
"Souda-Chania - Griechenland",
"Soufriere - St Lucia",
"Sousse - Tunisia",
"South Orkney Islands - Antarctica",
"South Plaza Island - Ecuador",
"South Shetland Islands - Antarctica",
"South Water Caye Belize - Belize",
"Southampton - Vereinigtes Königreich",
"Spanish Wells Bahamas - Bahamas",
"Speightstown - Barbados",
"Spetses Island - Griechenland",
"Speyer - Deutschland",
"Spitsbergen Island - Norwegen",
"Spitz an der Donau - Austria",
"Split - Kroatien",
"St Agnes Island England - Vereinigtes Königreich",
"St Anthony NL - Kanada",
"St Augustine FL - USA",
"St Croix Island USVI - US Virgin Islands",
"St Eustatius Island - Niederlande",
"St Francisville LA - USA",
"St George - Bermuda",
"St Georges Grenada - Grenada",
"St John Island USVI - US Virgin Islands",
"St Johns Antigua - Antigua & Barbuda",
"St Johns NL - Kanada",
"St Joseph Atoll Seychelles - Seychelles",
"St Kilda Islands Scotland - Vereinigtes Königreich",
"St Lawrence Island - USA",
"St Lawrence Seaway - Kanada",
"St Louis MO - USA",
"St Mary's Island England - Vereinigtes Königreich",
"St Marys GA - USA",
"St Matthew Island - USA",
"St Michaels MD - USA",
"St Paul Island - USA",
"St Petersburg FL - USA",
"St Simons Island GA - USA",
"St Thomas Island USVI - US Virgin Islands",
"Stadt Munster - Deutschland",
"Stadt Roth - Deutschland",
"Stadt Wehlen - Deutschland",
"Stamsund - Norwegen",
"Staniel Cay Bahamas - Bahamas",
"Stavanger - Norwegen",
"Stavoren - Niederlande",
"Stechovice - Czech Rep",
"Stevenson WA - USA",
"Stintino - Italien",
"Stockholm - Schweden",
"Stockton CA - USA",
"Stokmarknes - Norwegen",
"Stolzenau-Weser - Deutschland",
"Stornoway - Vereinigtes Königreich",
"Strait of Magellan - Chile",
"Stralsund - Deutschland",
"Stranraer-Cairnryan - Vereinigtes Königreich",
"Straubing - Deutschland",
"Stromboli Island - Italien",
"Stromness - Vereinigtes Königreich",
"Sturgeon Bay WI - USA",
"Stuttgart - Deutschland",
"Stykkisholmur - Island",
"Subic Bay Freeport - Philippines",
"Suez Canal - Ägypten",
"Sulfeld - Deutschland",
"Sulina - Romania",
"Sundsvall - Schweden",
"Sur City - Oman",
"Surabaya - Indonesia",
"Surtsey Island - Island",
"Suva - Fiji",
"Suzhou - China",
"Svalbard Islands - Norwegen",
"Svirstroy - Russia",
"Svishtov - Bulgaria",
"Svolvaer - Norwegen",
"Swansea UK - Vereinigtes Königreich",
"Swinoujscie - Polen",
"Sydkoster - Schweden",
"Sydney - Australien",
"Sydney NS - Kanada",
"Symi Island - Griechenland",
"Syros Island - Griechenland",
"Szczecin - Polen",
"Tacoma WA - USA",
"Tadoussac - Kanada",
"Taglio di Po - Italien",
"Tahaa Island - French Polynesia",
"Taichung - Taiwan",
"Tainan-Anping - Taiwan",
"Takakyla - Finnland",
"Takamatsu - Japan",
"Takoradi - Ghana",
"Talan Island - Russia",
"Talcahuano - Chile",
"Tallinn - Estland",
"Tamano - Japan",
"Tami Island PNG - Papua New Guinea",
"Tampa - USA",
"Tan Chau - Vietnam",
"Tangermunde - Deutschland",
"Tangier - Marokko",
"Tangier Island VA - USA",
"Tanna Island - Vanuatu",
"Tant Kyi Taung - Myanmar",
"Taranto - Italien",
"Tarascon - Frankreich",
"Tarragona - Spanien",
"Tartous - Syria",
"Tasiilaq - Greenland",
"Tauranga - New Zealand",
"Taveuni Island Fiji - Fiji",
"Tema Harbour-Accra - Ghana",
"Terre-de-Haut Island - Guadeloupe",
"Thasos Island - Griechenland",
"Thayetmyo - Myanmar",
"The Dalles OR - USA",
"The Hague - Niederlande",
"Thessaloniki - Griechenland",
"Thionville - Frankreich",
"Thorshofn - Island",
"Three Gorges Dam - China",
"Thunder Bay ON - Kanada",
"Thursday Island - Australien",
"Tianjin - China",
"Tigyaing - Myanmar",
"Tilos Island - Griechenland",
"Timaru - New Zealand",
"Tinian Island Marianas - USA",
"Tinkona Island - Bangladesh",
"Tinos Island - Griechenland",
"Tivat - Montenegro",
"Tivua Island Fiji - Fiji",
"Tiwi Islands Australia - Australien",
"Toamasina - Madagascar",
"Toba-Mie - Japan",
"Tobago Cays - St Vincent & Grenadines",
"Tobermory ON - Kanada",
"Tokushima - Japan",
"Tokyo - Japan",
"Tolagnaro - Madagascar",
"Toliara - Madagascar",
"Tomonoura-Fukuyama - Japan",
"Tonle Sap Lake - Cambodia",
"Topolobampo - Mexiko",
"Torbay UK - Vereinigtes Königreich",
"Torgau - Deutschland",
"Torishima Island Japan - Japan",
"Toronto - Kanada",
"Torretta-Legnago - Italien",
"Torshavn - Faroe Islands",
"Torsken - Norwegen",
"Tortola Island BVI - British Virgin Islands",
"Tortuga Island Costa Rica - Costa Rica",
"Torvik - Norwegen",
"Tory Island Ireland - Irland",
"Toulon - Frankreich",
"Tournon-sur-Rhone - Frankreich",
"Tournus - Frankreich",
"Townsville QLD - Australien",
"Toyama City - Japan",
"Toyohashi - Japan",
"Traben-Trarbach - Deutschland",
"Trabzon - Türkei",
"Tracy Arm Fjord - USA",
"Traena - Norwegen",
"Trapani - Italien",
"Travemunde-Lubeck - Deutschland",
"Traverse City MI - USA",
"Treasure Cay - Bahamas",
"Trebenice - Czech Rep",
"Treis-Karden - Deutschland",
"Trelleborg - Schweden",
"Tresco Island - Vereinigtes Königreich",
"Trevoux - Frankreich",
"Trier - Deutschland",
"Trieste - Italien",
"Trincomalee - Sri Lanka",
"Tripoli - Libya",
"Tristan da Cunha Island - Vereinigtes Königreich",
"Triton Bay - Indonesia",
"Trivandrum-Vizhinjam - India",
"Trobriand Islands PNG - Papua New Guinea",
"Trogir - Kroatien",
"Trois-Rivieres - Kanada",
"Trollfjord - Norwegen",
"Tromso - Norwegen",
"Trondheim - Norwegen",
"Troon - Vereinigtes Königreich",
"Troy NY - USA",
"Trujillo - Honduras",
"Tsuruga - Japan",
"Tsushima-Izuhara - Japan",
"Tuam Island PNG - Papua New Guinea",
"Tuamotus Islands - French Polynesia",
"Tufi - Papua New Guinea",
"Tuktoyaktuk - Kanada",
"Tulcea - Romania",
"Tunica MS - USA",
"Turku - Finnland",
"Turnu Magurele - Romania",
"Tutrakan - Bulgaria",
"Tver - Russia",
"Tvoroyri - Faroe Islands",
"Twillingate NL - Kanada",
"Tyuleny Island - Russia",
"Ua Huka Island - French Polynesia",
"Ua Pou Island - French Polynesia",
"Ubatuba - Brasilien",
"Ube-Yamaguchi City - Japan",
"Uelen - Russia",
"Uelzen - Deutschland",
"Uglich - Russia",
"Ullapool - Vereinigtes Königreich",
"Ulsan - Korea",
"Ulsteinvik - Norwegen",
"Ulukhaktok - Kanada",
"Ulva Island NZ - New Zealand",
"Ulva Island Scotland - Vereinigtes Königreich",
"Ulvik - Norwegen",
"Ulyanovsk - Russia",
"Umea - Schweden",
"Unga - USA",
"Union Island Grenadines - St Vincent & Grenadines",
"Unst Island - Vereinigtes Königreich",
"Upernavik - Greenland",
"Ushuaia - Argentinien",
"Usti nad Labem - Czech Rep",
"Utrecht - Niederlande",
"Uummannaq - Greenland",
"Uwajima - Japan",
"Vaasa - Finnland",
"Vadso - Norwegen",
"Vairao - French Polynesia",
"Vaitahu - French Polynesia",
"Valdez - USA",
"Valence - Frankreich",
"Valencia - Spanien",
"Valle Gran Rey - Spanien",
"Vallejo CA - USA",
"Valletta - Malta",
"Valparaiso-Santiago - Chile",
"Vancouver - Kanada",
"Vancouver WA - USA",
"Vanimo PNG - Papua New Guinea",
"Vannes - Frankreich",
"Vanua Balavu - Fiji",
"Vardo - Norwegen",
"Varna - Bulgaria",
"Vastervik - Schweden",
"Vavau Islands Tonga - Tonga",
"Veere - Niederlande",
"Vega de Terron-Salamanca - Spanien",
"Veliko Gradiste - Serbia",
"Venice - Fusina - Italien",
"Venice - Maghera - Italien",
"Venice - Porto di Venezia - Italien",
"Venice - San Basilio - Italien",
"Venlo - Niederlande",
"Ventspils - Latvia",
"Veracruz - Mexiko",
"Vernon - Frankreich",
"Verona - Italien",
"Vesteralen Islands - Norwegen",
"Viana do Castelo - Portugal",
"Vicksburg MS - USA",
"Victoria BC - Kanada",
"Victoria Falls - Zimbabwe",
"Vidin - Bulgaria",
"Vienna - Austria",
"Vienne - Frankreich",
"Vieques Island - Puerto Rico",
"Vieux Fort - St Lucia",
"Vigo - Spanien",
"Vigur Island - Island",
"Vikoyri - Norwegen",
"Vila Real de Santo Antonio - Portugal",
"Vilagarcia de Arousa - Spanien",
"Villefranche-sur-Mer - Frankreich",
"Villefranche-sur-Saone - Frankreich",
"Vilshofen an der Donau - Deutschland",
"Vinh Long - Vietnam",
"Virgin Gorda Island BVI - British Virgin Islands",
"Vis Island Croatia - Kroatien",
"Visakhapatnam - India",
"Visby - Schweden",
"Visegrad - Hungary",
"Vitoria - Brasilien",
"Viviers-sur-Rhone - Frankreich",
"Vladivostok - Russia",
"Vlissingen - Niederlande",
"Vlore - Albania",
"Vodice - Kroatien",
"Volgograd - Russia",
"Volkach - Deutschland",
"Volos - Griechenland",
"Vopnafjordur - Island",
"Vukovar - Kroatien",
"Vylkove - Ukraine",
"Wachau Valley - Austria",
"Waiheke Island NZ - New Zealand",
"Waikelo - Indonesia",
"Wakayama City - Japan",
"Wala Island - Vanuatu",
"Wallhamn - Schweden",
"Wallis and Futuna Islands - Frankreich",
"Waltenheim-sur-Zorn - Frankreich",
"Walvis Bay - Namibia",
"Warming Island Greenland - Greenland",
"Warnemunde-Rostock - Deutschland",
"Warren RI - USA",
"Warrenpoint - Vereinigtes Königreich",
"Warsaw - Polen",
"Washington DC - USA",
"Wasserbillig - Luxembourg",
"Waterford - Irland",
"Weissenkirchen in der Wachau - Austria",
"Welland Canal - Kanada",
"Wellington - New Zealand",
"Wertheim am Main - Deutschland",
"Wesel - Deutschland",
"West Falkland Island - Falkland Islands",
"West Palm Beach - USA",
"West Point NY - USA",
"Westray Island Scotland - Vereinigtes Königreich",
"Wewak PNG - Papua New Guinea",
"Weymouth - Vereinigtes Königreich",
"Whangarei - New Zealand",
"Wheeling WV - USA",
"White Island NZ - New Zealand",
"Whittier - USA",
"Wiencke Island - Antarctica",
"Wiesbaden - Deutschland",
"Wijk bij Duurstede - Niederlande",
"Willemstad Curacao - Niederlande",
"Willemstad NL - Niederlande",
"Willis Island - Australien",
"Wilmington NC - USA",
"Windsor ON - Kanada",
"Winningen-Mosel - Deutschland",
"Winona MN - USA",
"Wismar - Deutschland",
"Wolfsburg - Deutschland",
"Wolgast - Deutschland",
"Wolin - Polen",
"Woodlark Island - Papua New Guinea",
"Woody Point NL - Kanada",
"Worms - Deutschland",
"Wrangel Island - Russia",
"Wrangell AK - USA",
"Wuhan - China",
"Wurzburg - Deutschland",
"Wusterwitz - Deutschland",
"Wyndham WA - Australien",
"Xanten - Deutschland",
"Xeo Quyt Forest - Vietnam",
"Xiamen - China",
"Xian - China",
"Xouaxange - Frankreich",
"Yakushima Island Japan - Japan",
"Yalour Islands - Antarctica",
"Yalta - Russia",
"Yanbu Al-Bahr - Saudi Arabia",
"Yandabo - Myanmar",
"Yangon - Myanmar",
"Yantai - China",
"Yap Island Micronesia - Micronesia",
"Yaqeta Island Fiji - Fiji",
"Yarmouth NS - Kanada",
"Yaroslavl - Russia",
"Yasawa Island Fiji - Fiji",
"Yatsushiro-Kumamoto City - Japan",
"Yawajaba Island - Australien",
"Ybbs an der Donau - Austria",
"Yell Island - Vereinigtes Königreich",
"Yeosu - Korea",
"Yevpatoria - Russia",
"Yichang - China",
"Yirrkala - Australien",
"Yokkaichi - Japan",
"Yokohama - Japan",
"Yokosuka - Japan",
"York Island - Sierra Leone",
"Yorkeys Knob - Australien",
"Yorktown-Williamsburg VA - USA",
"Ystad - Schweden",
"Yueyang - China",
"Zaandam - Niederlande",
"Zadar - Kroatien",
"Zakynthos Island - Griechenland",
"Zanzibar - Tanzania",
"Zaporizhia - Ukraine",
"Zeebrugge - Belgien",
"Zeeland - Niederlande",
"Zell-Mosel - Deutschland",
"Zhujiajian Island - China",
"Zingst - Deutschland",
"Zutphen - Niederlande"
];
